var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"text":"","height":"64px"},on:{"click":_vm.create}},[_c('v-icon',[_vm._v("mdi-account-plus")]),_vm._v(" Create User ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }